import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  kitDetails: null,
  projects: [],
  eligibleOrders: [],
  sealTypes: [],
};

const assetDetailsSlice = createSlice({
  name: "assetDetails",
  initialState,
  reducers: {
    fetchKitDetails(state, action) {
      if (action.payload?.isLoading !== false) {
        state.loading = true;
        state.error = null;
        state.kitDetails = null;
      }
    },
    fetchKitDetailsSuccess(state, action) {
      state.kitDetails = action.payload.data;
      state.loading = false;
    },
    fetchKitDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload?.error || "Failed to fetch kit details";
    },
    fetchProjects(state, action) {
      state.projects = [];
    },
    fetchProjectsSuccess(state, action) {
      state.projects = action.payload?.data || [];
    },
    fetchProjectsFailure(state, action) {},
    updateProjectCode(state, action) {},
    updateProjectCodeSuccess(state, action) {},
    updateProjectCodeFailure(state, action) {},
    addSeals(state, action) {},
    addSealsSuccess(state, action) {},
    addSealsFailure(state, action) {},
    addBox(state, action) {},
    addBoxSuccess(state, action) {},
    addBoxFailure(state, action) {},
    deleteKit(state, action) {},
    deleteKitSuccess(state, action) {},
    deleteKitFailure(state, action) {},

    fetchEligibleOrders(state, action) {
      state.eligibleOrders = [];
    },
    fetchEligibleOrdersSuccess(state, action) {
      state.eligibleOrders = action.payload || [];
    },
    fetchEligibleOrdersFailure(state, action) {
      state.eligibleOrders = [];
    },
    addOrdersToBox(state, action) {},
    addOrdersToBoxSuccess(state, action) {},
    addOrdersToBoxFailure(state, action) {},
    removeOrderFromBox(state, action) {},
    removeOrderFromBoxSuccess(state, action) {},
    removeOrderFromBoxFailure(state, action) {},
    changeBoxStatus(state, action) {},
    changeBoxStatusSuccess(state, action) {},
    changeBoxStatusFailure(state, action) {},
    markSealAsUnused(state, action) {},
    markSealAsUnusedSuccess(state, action) {},
    markSealAsUnusedFailure(state, action) {},

    getSampleSealTypes(state, action) {},
    getSampleSealTypesSuccess(state, action) {
      state.sealTypes = action.payload?.data?.sealTypes || [];
    },
    getSampleSealTypesFailure(state, action) {},

    addSticker(state, action) {},
    addStickerSuccess(state, action) {},
    addStickerFailure(state, action) {},

    addDevice(state, action) {},
    addDeviceSuccess(state, action) {},
    addDeviceFailure(state, action) {},
  },
});

export const { actions, reducer, name: sliceKey } = assetDetailsSlice;